import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import BurgerIcon from './BurgerIcon';
import Menu from './Menu';
import '../BurgerMenu/BurgerMenu.scss';
import '../Header.scss';
import logo from '../../../../assets/images/Home/logo2.svg';

const BurgerMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    const burgerRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();

    const toggleMenu = useCallback(() => {
        setIsOpen((prev) => !prev);
    }, []);

    const closeMenu = useCallback(() => {
        setIsOpen(false);
    }, []);

    const handleLinkClick = (event, to) => {
        event.preventDefault();
        closeMenu();
        navigate(to);
    };

    const handleLogoClick = () => {
        if (location.pathname === '/') {
            window.location.reload();
        } else {
            navigate('/');
        }
    };

    const handleClickOutside = useCallback((event) => {
        if (
            menuRef.current && !menuRef.current.contains(event.target) &&
            burgerRef.current && !burgerRef.current.contains(event.target)
        ) {
            closeMenu();
        }
    }, [closeMenu]);

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, handleClickOutside]);

    return (
        <>
            <div className="logo">
                <Link to="/" onClick={handleLogoClick}>
                    <img className='perks_image_pic' src={logo} alt='digitalcake'/>
                </Link>
            </div>
            <div className="tel">
                <Link className='num' to='tel:+12153885043'>+1 215 388 50 43</Link>
                <p className='add'>300 Cottman Street, Jenkintown, PA</p>
            </div>
            <BurgerIcon
                isOpen={isOpen}
                toggleMenu={toggleMenu}
                ref={burgerRef}
            />
            <Menu
                isOpen={isOpen}
                handleLinkClick={handleLinkClick}
                menuRef={menuRef}
                toggleMenu={toggleMenu}
            />
        </>
    );
};

export default BurgerMenu;